import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Reusable callback modal component to reduce duplication across product modals.
 * Replaces speakToCoachConfirmationModel, idpConfirmationModel, callbackConfirmationModel,
 * tfgCallBackModel, and other similar callback modals.
 */
@Component({
  selector: 'app-callback-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './callback-modal.component.html',
  styleUrls: ['./callback-modal.component.css']
})
export class CallbackModalComponent {
  @Input() headerLabel = 'call me back';
  @Input() title = 'Free callback request';
  @Input() promptText = 'Do you want a coach to call you?';
  @Input() successMsg = '';
  @Input() errorMsg = '';
  @Input() yesButtonId = 'CallbackYes';
  @Input() noButtonId = 'CallbackNo';
  @Input() yesButtonName = 'CallbackYes';
  @Input() yesButtonLabel = 'Yes';
  @Input() noButtonLabel = 'No';
  /** Set false for a popup with a single action button. */
  @Input() showNoButton = true;
  @Input() noButtonName = 'CallbackNo';
  @Input() closeButtonId = '';
  @Input() closeButtonName = '';
  @Input() showCloseButton = true;

  @Output() yesClick = new EventEmitter<void>();
  @Output() noClick = new EventEmitter<void>();
  @Output() closeClick = new EventEmitter<void>();

  get showPrompt(): boolean {
    return !this.successMsg && !this.errorMsg;
  }

  get showFooter(): boolean {
    return !this.successMsg && !this.errorMsg;
  }

  onYesClick(): void {
    this.yesClick.emit();
  }

  onNoClick(): void {
    this.noClick.emit();
  }

  onCloseClick(): void {
    this.closeClick.emit();
  }
}
